import React, { Component } from 'react';
import '../../../Assets/EnsembleStyles/EnsHome.css';
import { Modal } from 'reactstrap';
import NavigationBar from '../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';                                    /* Navigation Bar */
import TitleBar from '../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';                                              /* Titile  Bar */
import Footer from '../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import Idle from 'react-idle';
import InactiveWindow from '../../Logout/InActive';



// SubRouting
import AdministrationSubRouting from '../Common/Layouts/SubRouting/AdministrationSubRouting';



export default class Administration extends Component {

    showSettings(event) {
        event.preventDefault();
    }

    constructor(props) {
        super(props);
        this.state = {
            sideSize: 300,
            drag: 300,
            inactive_modal: false,
            LogOffTime: 1200000
        }
        this.Inactivetoggle = this.Inactivetoggle.bind(this);
    }

    componentWillMount(){
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }

    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    Extend_Session = (someArg) => {
        this.setState({
            inactive_modal: false
        });
    }


    render() {
        return (
            <div className="Ensemble">

               <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
            if (idle && !this.state.OnPremisesState) {
                 this.setState({ inactive_modal: true });
            }
        }} /> 

            {/* Navigation Bar */}
                <NavigationBar />  

            {/* Title bar displays the title of the page */}
                <TitleBar parentToChildData={"Administration"} istabView={false}/>  

                 <div className="Ensemble_Content margin_top">
                    <AdministrationSubRouting  match={this.props.match}  /> 

                </div>

                 <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={ "ModalContainer InActive_Short_Modal"} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                 </Modal>


                {/* Side Bar */}
                {/* <SplitPane split="vertical" size={this.state.sideSize} onChange={this.handleDrag} >
                    <div className="sidePane">
                        <Sidebar />
                        <span className={"closebutton " + (this.state.drag <= 1 ? "hidden" : "")} onClick={() => this.toggleSide("close")} style={{ left: this.state.drag + 'px' }}>
                            <FaDoubleLeft className="icon" />
                        </span>
                        <span className={"openbutton " + (this.state.drag > 1 ? "hidden" : "")} onClick={() => this.toggleSide("open")} style={{ left: this.state.drag + 'px' }}>
                            <FaDoubleRight className="icon" />
                        </span>
                    </div>
                    <div className="">

                    <AdministrationSubRouting  match={this.props.match}  /> 

                    </div>
                </SplitPane> */}

                {/* Footer */}
                <Footer />
            </div>
        );
    }
}
